import * as React from "react";
import type { SVGProps } from "react";
const SvgMeh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 14a1 1 0 1 0 0 2zm8 2a1 1 0 1 0 0-2zM9 8a1 1 0 0 0 0 2zm.01 2a1 1 0 0 0 0-2zM15 8a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zM8 16h8v-2H8zm1-6h.01V8H9zm6 0h.01V8H15z"
    />
  </svg>
);
export default SvgMeh;
